var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    color: "#363A3A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hourglass-01",
    clipPath: "url(#clip0_134_222191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.49935 4.00001L2.25309 2.96146C2.06793 2.80716 1.97534 2.73001 1.90879 2.63543C1.84981 2.55163 1.80602 2.45813 1.77939 2.35918C1.74935 2.2475 1.74935 2.12698 1.74935 1.88595V1.08334M3.49935 4.00001L4.74561 2.96146C4.93077 2.80716 5.02335 2.73001 5.08991 2.63543C5.14889 2.55163 5.19268 2.45813 5.2193 2.35918C5.24935 2.2475 5.24935 2.12698 5.24935 1.88595V1.08334M3.49935 4.00001L2.25309 5.03856C2.06793 5.19286 1.97534 5.27001 1.90879 5.36459C1.84981 5.44839 1.80602 5.54189 1.77939 5.64084C1.74935 5.75252 1.74935 5.87304 1.74935 6.11407V6.91668M3.49935 4.00001L4.74561 5.03856C4.93077 5.19286 5.02335 5.27001 5.08991 5.36459C5.14889 5.44839 5.19268 5.54189 5.2193 5.64084C5.24935 5.75252 5.24935 5.87304 5.24935 6.11407V6.91668M1.16602 1.08334H5.83268M1.16602 6.91668H5.83268",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_222191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.c9407d505ab5c8f12d9cd39066793189.svg";
export { ForwardRef as ReactComponent };